import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import defaultAvatar from '../../../images/default-avatar.png';

import styles from './styles.m.scss';

const propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  square: PropTypes.bool,
  src: PropTypes.string,
  mini: PropTypes.bool,
  large: PropTypes.bool,
};

function Avatar({ className, square, src, mini, large }) {
  return (
    <div
      className={cn(
        {
          [styles.mini]: mini,
          [styles.large]: large,
        },
        square ? styles.square : styles.circle,
        styles.avatar,
        className,
      )}
    >
      <img alt="avatar" src={src ? src : defaultAvatar} />
    </div>
  );
}

Avatar.propTypes = propTypes;

export default Avatar;
